import {
    DashboardOutlined,
    ShopOutlined,
    FileSearchOutlined,
    FileDoneOutlined,
    PushpinOutlined,
    SearchOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';


export const menuConfig = {
    customer_care: [
        {
            key: 'dashboard',
            label: <Link to="/dashboard">Dashboard</Link>,
            icon: <DashboardOutlined />
        },
        {
            key: 'masters',
            label: <Link to="/masters">Master List</Link>,
            icon: <ShopOutlined />
        },
        {
            key: 'other-branch-stock',
            label: <Link to="/other-branch-stock">Stock</Link>,
            icon: <FileSearchOutlined />
        },
        {
            key: 'sales-invoice',
            label: <Link to="/sales-invoice">Sales Invoice</Link>,
            icon: <FileDoneOutlined />
        },
//        {
//            key: 'imei-search',
//            label: <Link to="/imei-search">IMEI Search</Link>,
//            icon: <FormOutlined />
//        },
        {
            key: 'push-lead',
            label: <Link to="/push-lead">Push Lead</Link>,
            icon: <PushpinOutlined />
        },
        {
            key: 'about-2-0',
            label: <Link to="/about-2-0">About 2.0</Link>,
            icon: <SearchOutlined />
        },
    ]
};
